import { useIntl } from "react-intl";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { useDataRequestForm } from "./useDataRequestForm";
import DataRequestForm from "./components/DataRequestForm";
import DataRequestAbout from "./components/DataRequestAbout";
import DataRequestContent from "./components/DataRequestContent";
import "./../subscribeForm/SubscribeForm.scss";

function DataRequest() {
  const intl = useIntl();
  const {
    dir,
    currentLocale,
    userInfo,
    isLoading,
    register,
    handleSubmit,
    errors,
    onSubmit,
    getDepartment,
    servicesTools,
  } = useDataRequestForm();

  return (
    <ContentLoading isLoading={isLoading}>
      <div className="data-request">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "data-request" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "data-request-service" })}
          route={"../servicestools"}
        />
        <div className="container py-5">
          <div className="row">
            <DataRequestForm
              dir={dir}
              currentLocale={currentLocale}
              userInfo={userInfo}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              onSubmit={onSubmit}
            />
            <DataRequestAbout servicesTools={servicesTools} />
          </div>
          <DataRequestContent
            currentLocale={currentLocale}
            servicesTools={servicesTools}
            getDepartment={getDepartment}
          />
        </div>
      </div>
    </ContentLoading>
  );
}

export default DataRequest;
